/* eslint-disable consistent-return */
import * as routes from '../../actions/routing/route.actions'

const routingCheckMiddleware = ({ dispatch, getState }) => next => (action) => {
    const { type, payload } = action

    const goHomeYouAreDrunk = () => {
        console.log('# ILLEGAL PAGE LOAD #')
        dispatch(routes.goToHome())
    }

    switch (type) {
        case routes.GOTO_UNIT: {
            const { unitID } = payload
            const { roster } = getState()
            if (!roster[unitID]) {
                goHomeYouAreDrunk()
                break
            }
            next(action)
            break
        }
        case routes.GOTO_BATTLE_RESULT: {
            const { battleStage } = getState()
            if (!battleStage) {
                goHomeYouAreDrunk()
                break
            }
            next(action)
            break
        }
        default: {
            next(action)
        }
    }
}

export default routingCheckMiddleware
